import React, { useState } from 'react';
import { Typography, Box, Button, useMediaQuery, useTheme, Grid } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StepButtonBar } from '../EditLegalListWizard/StepButtonBar';
import { StepProps } from './types';
import UpdateConnectionInfo from './UpdateConnectionInfo';

const PRIMARY = '#c4122f';

interface Step0SelectViewProps extends StepProps {
  selectedView?: 'law' | 'connection';
  onViewSelect: (view: 'law' | 'connection') => void;
  currentStepName: string;
  updateConnectionInfo: any;
  setUpdateConnectionInfo: (info: any) => void;
}

const Step0SelectView = ({
  onNext,
  onBack,
  onCancel,
  isFirstStep,
  selectedView,
  onViewSelect,
  currentStepName,
  updateConnectionInfo,
  setUpdateConnectionInfo,
}: Step0SelectViewProps) => {
  const [localSelectedView, setLocalSelectedView] = useState<'law' | 'connection' | undefined>(selectedView);
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);

  const handleSelectView = (view: 'law' | 'connection') => {
    setLocalSelectedView(view);
  };

  const handleNext = () => {
    if (localSelectedView) {
      onViewSelect(localSelectedView);
      onNext();
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '350px',
          }}
        >
          <Box style={{ maxWidth: '320px', width: '100%' }}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  variant={localSelectedView === 'law' ? 'contained' : 'outlined'}
                  onClick={() => handleSelectView('law')}
                  style={{
                    padding: isMobile ? '18px 24px' : '22px 32px',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: 700,
                    color: localSelectedView === 'law' ? '#fff' : PRIMARY,
                    background: localSelectedView === 'law' ? PRIMARY : 'transparent',
                    width: '100%',
                    minWidth: '230px',
                    borderRadius: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    transition: 'all 0.2s ease',
                    border: `2px solid ${PRIMARY}`,
                  }}
                >
                  {formatMessage({ id: 'law-portal.manage.update-laws.view.law' })}
                </Button>
              </Grid>
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  variant={localSelectedView === 'connection' ? 'contained' : 'outlined'}
                  onClick={() => handleSelectView('connection')}
                  style={{
                    padding: isMobile ? '18px 24px' : '22px 32px',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: 700,
                    color: localSelectedView === 'connection' ? '#fff' : PRIMARY,
                    background: localSelectedView === 'connection' ? PRIMARY : 'transparent',
                    width: '100%',
                    minWidth: '230px',
                    borderRadius: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    transition: 'all 0.2s ease',
                    border: `2px solid ${PRIMARY}`,
                  }}
                >
                  {formatMessage({ id: 'law-portal.manage.update-laws.view.connection' })}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </div>
        <UpdateConnectionInfo
          updateConnectionInfo={updateConnectionInfo}
          currentStepName={currentStepName}
          onUpdate={setUpdateConnectionInfo}
        />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="form.next"
          nextDisabled={!localSelectedView}
          formatMessage={formatMessage}
          showBack={!isFirstStep}
        />
      </Box>
    </div>
  );
};

export default Step0SelectView;
